const getOrderDescMixin = {
    methods: {
        getOrderDesc (order) {
            if (!order) return []
            const {
                orderNo,
                buyerName,
                buyerMobile,
                buyerRemarks,
                totalPoints
            } = order.pointsOrder
            const {
                receiverPostProvinceName,
                receiverPostCityName,
                receiverAddress,
                receiverName,
                receiverMobile
            } = order?.pointsOrderAddress || {}

            const result = [
                { key: '订单号', value: orderNo, span: 1 },
                { key: '采购人', value: buyerName, span: 1 },
                { key: '采购人手机', value: buyerMobile, span: 2 },
                { key: '采购人备注', value: buyerRemarks, span: 6 },
                { key: '收货人', value: `${receiverName || ''}`, span: 6 },
                { key: '收货人手机号', value: `${receiverMobile || ''}`, span: 6 },
                { key: '收货地址', value: `${receiverPostProvinceName || ''} ${receiverPostCityName || ''} ${receiverAddress || ''}`, span: 6 },
                { key: '订单总积分', value: `${totalPoints}`, span: 6 }
            ]
            return result
        }
    }
}

export default getOrderDescMixin
